import React, {useEffect, useRef, useState} from 'react'
import Slider from 'react-slick';
import Lightbox from 'react-image-lightbox';
import "react-image-lightbox/style.css";

export default function LandscapSlider({data, startIndex = 0}) {

    const [current, setCurrent] = useState('');

    const sliderRef = useRef(null);

    const next = () => {
        sliderRef.current.slickNext();
    };
    const previous = () => {
        sliderRef.current.slickPrev();
    };

    useEffect(() => {
        if (data && data.length && sliderRef?.current) {
            sliderRef.current.slickGoTo(Math.min(startIndex, data.length - 1), true);
        }
    }, [data, startIndex]);

    var settings = {
        dots: false,
        speed: 500,
        pading: '10px',
        slidesToShow: 1,
        slidesToScroll: 1,
        className: 'light_box',
        autoplay: true,
        autoplaySpeed: 7700,
        pauseOnHover: false,
        pauseOnFocus: false,
    };


    const handleClickImage = (e, i) => {
        setCurrent(i);
    };

    const handleCloseModal = (e) => {
        setCurrent('');
    };

    return (
        <>
            <div className="pointer slider_btn_previos" onClick={previous}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                    <g id="SVGRepo_iconCarrier">
                        <path d="M15 4 L7 12 L15 20" stroke="#000000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                </svg>
            </div>
            <div className="pointer slider_btn_next" onClick={next}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                    <g id="SVGRepo_iconCarrier">
                        <path d="M9 4 L17 12 L9 20" stroke="#000000" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                </svg>
            </div>
            <div className="slider-container mt-20">
                <Slider ref={sliderRef}
                        {...settings}>
                    {data?.length > 0 &&
                        data?.map((i, index) =>
                            <div key={index} className='center_image'>
                                <div className="sport_card" onClick={(e) => handleClickImage(e, i)}>
                                    <img src={i}/>
                                </div>
                            </div>
                        )}
                </Slider>
                {current &&
                    <Lightbox
                        mainSrc={current}
                        onCloseRequest={handleCloseModal}
                    />
                }
            </div>
        </>
    )
}